
export default [
  {
    path: '/admin/daily-expenses',
    name: 'daily-expense',
    meta: { requiresAuth: true },
    component: () => import('@/pages/expense/daily-expense')
  }
]
